import { LocaleId } from '@domgen/dgx-fe-i18n';

export interface AdobeRequest {
  brand: string;
  cleartext: string;
  email: string;
  eventType: string;
  externalId: string;
  firstName?: string;
  language: LocaleId;
  lastName?: string;
  modelNum: string;
  name: string;
  origin: string;
  serialNum?: string;
}
